import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-repair-appointment',
  templateUrl: './repair-appointment.component.html',
  styleUrls: ['./repair-appointment.component.css']
})
export class RepairAppointmentComponent implements OnInit {

  public menu_item_id = '78';

  model = {
    'table_name': 'appointment', 'appointment_id': '0', 'appointment_date': '',
    'customer_no': '', 'comment': ''
  };

  date_model = { 'appointment_date': new Date(), 'today': new Date(), 'hours': '00', 'minutes': '00' };

  search_obj = {
    'placeholder': '', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'represent1', 'represent1_mobile']
    }]
  };

  hoursList = [];
  minutesList = [];
  isNew_app = true;
  Appoint_Date_Msg;
  Select_Car_Msg;
  Success_Msg;
  Error_Msg;
  Request_No;
  Early_appoint_Msg;
  Car_Search_Field;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<RepairAppointmentComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {
    //this.compName = this.utils.getParamValue('company_name_' + this.applicationConstants.user_lang);

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Appoint_Date_Msg').subscribe((res: string) => {
      this.Appoint_Date_Msg = res;
    });

    translate.get('Select_Car_Msg').subscribe((res: string) => {
      this.Select_Car_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Request_No').subscribe((res: string) => {
      this.Request_No = res;
    });

    translate.get('Early_appoint_Msg').subscribe((res: string) => {
      this.Early_appoint_Msg = res;
    });

    translate.get('Car_Search_Field').subscribe((res: string) => {
      this.Car_Search_Field = res;
    });
    this.search_obj['placeholder'] = this.Car_Search_Field;
  }
  ngOnInit() {

    // fill hoursList
    let value = '';

    for (let i = 0; i < 24; i++) {
      if (i >= 0 && i < 10)
        value = '0' + i;
      else
        value = String(i);

      this.hoursList.push({ key: value, value: value });
    }

    // fill minutesList
    for (let i = 0; i < 60; i++) {
      if (i >= 0 && i < 10)
        value = '0' + i;
      else
        value = String(i);

      this.minutesList.push({ key: value, value: value });
    }

    if (this.dialog_data != null) {
      this.model = this.dialog_data;

      this.date_model['appointment_date'] = new Date(this.model['appointment_date']);
      //(document.getElementById('appointment_time') as HTMLInputElement).value = this.model['appointment_time'];
      this.date_model['hours'] = (this.model['appointment_date']).substring(11, 13);
      this.date_model['minutes'] = (this.model['appointment_date']).substring(14, 16);

      let query = "SELECT * FROM `customer` WHERE `customer_no` = '" + this.model['customer_no'] + "' AND `status` = '1'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let customer = data.data['list'];
          (document.getElementById('search_value_0') as HTMLInputElement).value = customer['0']['customer_no'] + "-"
            + customer['0']['customer_name'] + "-" + customer['0']['customer_name_en'] + "-" + customer['0']['represent1'] + "-" + customer['0']['represent1_mobile'];
        });
      this.isNew_app = false;
    }
  }

  onChangeSearch = function (search_result: object) {
    this.model['customer_no'] = search_result['no'];
  }

  add() {
    if (this.date_model['appointment_date'] == undefined)
      alert(this.Appoint_Date_Msg);
    else if (this.model['customer_no'] == '')
      alert(this.Select_Car_Msg);

    else {
      if (this.isNew_app) {
        let today_date = (this.date_model['today'].getFullYear() + "-" +
          (this.date_model['today'].getMonth() + 1) + "-" + this.date_model['today'].getDate());

        let query = "SELECT * FROM `appointment` WHERE `customer_no` = '" + this.model['customer_no'] +
          "' AND `appointment_date` > '" + today_date + "' AND `status` = '1'";
        let obj1 = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let app_date = [];
            app_date = data.data['list'];
            //console.log(app_date);

            if (app_date.length > 0) {
              alert(this.Early_appoint_Msg);
              this.model = {
                'table_name': 'appointment', 'appointment_id': app_date['0']['appointment_id'],
                'appointment_date': app_date['0']['appointment_date'],
                'customer_no': app_date['0']['customer_no'], 'comment': app_date['0']['comment']
              }
              this.date_model['appointment_date'] = new Date(this.model['appointment_date']);
              this.date_model['hours'] = (this.model['appointment_date']).substring(11, 13);
              this.date_model['minutes'] = (this.model['appointment_date']).substring(14, 16);
              //(document.getElementById('appointment_time') as HTMLInputElement).value = this.model['appointment_time'];

              this.isNew_app = false;
            }

            else {
              this.model['appointment_date'] = this.date_model['appointment_date'].getFullYear() + "-" +
                (this.date_model['appointment_date'].getMonth() + 1) + "-" + 
                this.date_model['appointment_date'].getDate() + ' ' + 
                this.date_model['hours'] + ':' + this.date_model['minutes'] + ':00';
              //this.model['appointment_time'] = String(this.date_model['appointment_time']);

              let values = [];
              values.push(this.model);

              let obj = { cmd: 'add', values: values };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  console.log(data);
                  if (data.status['type'] == 'success') {
                    alert(this.Success_Msg + ' ' + this.Request_No + ': ' + data.status['msg']['0']['id']);
                    // this.dialog_data = {
                    //   'status': data.status['type']
                    // };
                    this.dialog_data = { 'op_type': 'success' };
                    this.dialogRef.close(this.dialog_data);
                    // this.router.navigate(['sub_menu/12/maint_request']);
                  }
                  else {
                    alert(this.Error_Msg);
                  }
                });
            }
          });
      }
      else
        this.update();
    }
  }

  update() {
    this.model['appointment_date'] = this.date_model['appointment_date'].getFullYear() + "-" +
      (this.date_model['appointment_date'].getMonth() + 1) + "-" + this.date_model['appointment_date'].getDate() +
      ' ' + this.date_model['hours'] + ':' + this.date_model['minutes'] + ':00';
    //this.model['appointment_time'] = String(this.date_model['appointment_time']);
    let values = [];
    values.push(this.model);

    let obj;
    let where = [{ 'appointment_id': this.model['appointment_id'] }];
    obj = { cmd: 'update', values: values, where: where };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          alert(this.Success_Msg + ' ' + this.Request_No + ': ' + this.model['appointment_id']);
          // this.dialog_data = {
          //   'status': data.status['type']
          // };
          this.dialog_data = { 'op_type': 'success' };
          this.dialogRef.close(this.dialog_data);
          // this.router.navigate(['sub_menu/12/maint_request']);
        }
        else {
          alert(this.Error_Msg);
        }
      });
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
